import React from 'react';
import ModalWrapper from '../../components/elements/ModalWrapper';
import { Image, Stack, Text, Textarea } from '@mantine/core';
import { Button } from '@mantine/core';
import { FiTrash } from 'react-icons/fi';
import { Card, FormGroup, Input , Col, Row} from 'reactstrap';
import Select from 'react-select/src/Select';
import moment from 'moment';
import { TextArea } from '../../components/textarea';
import { useState } from 'react';
import './style.scss'

interface ModalDetailProps {
    data: any;
    title?: string;
    isVisible: boolean;
    cancelText?: string;
    onClose: () => void;
    onConfirmation: (type: string) => void;
    reason?: string;
    loading?: boolean;
  }

const ModalDetail: React.FC<ModalDetailProps> = ({
    isVisible,
    onClose,
    onConfirmation,
    title,
    cancelText,
    data,
    loading
  }) => {

    const [reason, setReason] = useState('');
    const [error, setError] = useState('');

    const handleReasonChange = (val) => {
      if(val === ''){
        setReason('');
        setError('Reason is required');
        return
      }
      setReason(val);
      setError('');
    };

    const handleSubmitRevoke = () => {
        onConfirmation("delete");
    };

    const handleSubmitEdit = () => {
        onConfirmation("edit")
    }

    const renderContent = () => {
     {/* Detail Active (original) */}
     //  console.log(data.UpdatedReason)
    //   console.log(data)
      if(data.Status === '001' && !data.UpdatedReason && !data.RevokedReason && Date.now() >= new Date(data.EndDate).getTime()){
        return(
          <div>
          <div>
            <div className='select-wrapper'>
                <p>Delegated Employee Name</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    value={data.DelegatedName}
                    type="text"
                    />
                </FormGroup>
                           
            </div>
            <div>
                <p>Delegated Task</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={data.TaskDelegated}
                    />
                </FormGroup>
                           
            </div>
            <div>
                <p>Start Date</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={moment(data.StartDate).format("DD/MM/YYYY")}
                    />
                </FormGroup>
                           
            </div>
            <div>
                <p>End Date</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={moment(data.EndDate).format("DD/MM/YYYY")}
                    />
                </FormGroup>
                           
            </div>
            <div>
                <p>Created By</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={data.CreatorName}
                    />
                </FormGroup>
                           
            </div>
           
            <div>
                <p>Created Date</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={moment(data.DateIn).format("DD/MM/YYYY")}
                    />
                </FormGroup>
                           
            </div>
           
            {/* <div className='modal-detail-buttons-div'>
                    <div className="wrapper-modal-delete__content__actions">
                    <Button
                        // variant="error"
                        onClick={() => handleSubmitRevoke()}
                        color='red'
                        >
                        {data.deleteText}
                    </Button>
                    </div>
                    <div className="wrapper-modal-delete__content__actions">
                    <Button
                        // variant="error"
                        onClick={() => handleSubmitEdit()}
                        color='orange'
                        >
                        Edit
                    </Button>
                    </div>
            </div> */}

          </div>
        </div>
        )
      }
      else if(data.Status === '001' && !data.UpdatedReason && !data.RevokedReason){
        return(
          <div>
          <div>
            <div className='select-wrapper'>
                <p>Delegated Employee Name</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    value={data.DelegatedName}
                    type="text"
                    />
                </FormGroup>
                           
            </div>
            <div>
                <p>Delegated Task</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={data.TaskDelegated}
                    />
                </FormGroup>
                           
            </div>
            <div>
                <p>Start Date</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={moment(data.StartDate).format("DD/MM/YYYY")}
                    />
                </FormGroup>
                           
            </div>
            <div>
                <p>End Date</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={moment(data.EndDate).format("DD/MM/YYYY")}
                    />
                </FormGroup>
                           
            </div>
            <div>
                <p>Created By</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={data.CreatorName}
                    />
                </FormGroup>
                           
            </div>
           
            <div>
                <p>Created Date</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={moment(data.DateIn).format("DD/MM/YYYY")}
                    />
                </FormGroup>
                           
            </div>
           
            <div className='modal-detail-buttons-div'>
                    <div className="wrapper-modal-delete__content__actions">
                    <Button
                        // variant="error"
                        onClick={() => handleSubmitRevoke()}
                        color='red'
                        >
                        {data.deleteText}
                    </Button>
                    </div>
                    <div className="wrapper-modal-delete__content__actions">
                    <Button
                        // variant="error"
                        onClick={() => handleSubmitEdit()}
                        color='orange'
                        >
                        Edit
                    </Button>
                    </div>
            </div>

          </div>
        </div>
        )
      }
      else if(data.Status === '001' && data.UpdatedReason && !data.RevokedReason && Date.now() >= new Date(data.EndDate).getTime()){
        return(
          <div>
          <div>
            <div className='select-wrapper'>
                <p>Delegated Employee Name</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    value={data.DelegatedName}
                    type="text"
                    />
                </FormGroup>
                           
            </div>
            <div>
                <p>Delegated Task</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={data.TaskDelegated}
                    />
                </FormGroup>
                           
            </div>
            <div>
                <p>Start Date</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={moment(data.StartDate).format("DD/MM/YYYY")}
                    />
                </FormGroup>
                           
            </div>
            <div>
                <p>End Date</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={moment(data.EndDate).format("DD/MM/YYYY")}
                    />
                </FormGroup>
                           
            </div>
            <div>
                <p>Created By</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={data.CreatorName}
                    />
                </FormGroup>
                           
            </div>
           
            <div>
                <p>Created Date</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={moment(data.DateIn).format("DD/MM/YYYY")}
                    />
                </FormGroup>
                           
            </div>
            <div>
                <p>Updated By</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={data.UpdateName}
                    />
                </FormGroup>
                           
            </div>
            <div>
                <p>Updated Date</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={moment(data.DateUp).format("DD/MM/YYYY")}
                    />
                </FormGroup>
                           
            </div>
            <div>
                <p>Reason Update</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={data.UpdatedReason}
                    />
                </FormGroup>
                           
            </div>
           
            {/* <div className='modal-detail-buttons-div'>
                    <div className="wrapper-modal-delete__content__actions">
                    <Button
                        // variant="error"
                        onClick={() => handleSubmitRevoke()}
                        color='red'
                        >
                        {data.deleteText}
                    </Button>
                    </div>
                    <div className="wrapper-modal-delete__content__actions">
                    <Button
                        // variant="error"
                        onClick={() => handleSubmitEdit()}
                        color='orange'
                        >
                        Edit
                    </Button>
                    </div>
            </div> */}

          </div>
        </div>
        )
      }
      else if(data.Status === '001' && data.UpdatedReason && !data.RevokedReason){
        return(
          <div>
          <div>
            <div className='select-wrapper'>
                <p>Delegated Employee Name</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    value={data.DelegatedName}
                    type="text"
                    />
                </FormGroup>
                           
            </div>
            <div>
                <p>Delegated Task</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={data.TaskDelegated}
                    />
                </FormGroup>
                           
            </div>
            <div>
                <p>Start Date</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={moment(data.StartDate).format("DD/MM/YYYY")}
                    />
                </FormGroup>
                           
            </div>
            <div>
                <p>End Date</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={moment(data.EndDate).format("DD/MM/YYYY")}
                    />
                </FormGroup>
                           
            </div>
            <div>
                <p>Created By</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={data.CreatorName}
                    />
                </FormGroup>
                           
            </div>
           
            <div>
                <p>Created Date</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={moment(data.DateIn).format("DD/MM/YYYY")}
                    />
                </FormGroup>
                           
            </div>
            <div>
                <p>Updated By</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={data.UpdateName}
                    />
                </FormGroup>
                           
            </div>
            <div>
                <p>Updated Date</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={moment(data.DateUp).format("DD/MM/YYYY")}
                    />
                </FormGroup>
                           
            </div>
            <div>
                <p>Reason Update</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={data.UpdatedReason}
                    />
                </FormGroup>
                           
            </div>
           
            <div className='modal-detail-buttons-div'>
                    <div className="wrapper-modal-delete__content__actions">
                    <Button
                        // variant="error"
                        onClick={() => handleSubmitRevoke()}
                        color='red'
                        >
                        {data.deleteText}
                    </Button>
                    </div>
                    <div className="wrapper-modal-delete__content__actions">
                    <Button
                        // variant="error"
                        onClick={() => handleSubmitEdit()}
                        color='orange'
                        >
                        Edit
                    </Button>
                    </div>
            </div>

          </div>
        </div>
        )
      }
      else if(data.Status !== '001' && data.RevokedReason){
        return(
          <div>
          <div>
            <div className='select-wrapper'>
                <p>Delegated Employee Name</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    value={data.DelegatedName}
                    type="text"
                    />
                </FormGroup>
                           
            </div>
            <div>
                <p>Delegated Task</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={data.TaskDelegated}
                    />
                </FormGroup>
                           
            </div>
            <div>
                <p>Start Date</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={moment(data.StartDate).format("DD/MM/YYYY")}
                    />
                </FormGroup>
                           
            </div>
            <div>
                <p>End Date</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={moment(data.EndDate).format("DD/MM/YYYY")}
                    />
                </FormGroup>
                           
            </div>
            <div>
                <p>Created By</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={data.CreatorName}
                    />
                </FormGroup>
                           
            </div>
           
            <div>
                <p>Created Date</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={moment(data.DateIn).format("DD/MM/YYYY")}
                    />
                </FormGroup>
                           
            </div>
            <div>
                <p>Revoked By</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={data.RevokedName}
                    />
                </FormGroup>
                           
            </div>
            <div>
                <p>Reason Revoked</p>
                <FormGroup>
                    <Input
                    disabled = {true}
                    type ="text"
                    value={data.RevokedReason}
                    />
                </FormGroup>
                           
            </div>

          </div>
        </div>
        )
      }
      else if(data.Status !== '001' && !data.RevokedReason && !data.UpdatedReason){
        return(
            <div>
            <div>
              <div className='select-wrapper'>
                  <p>Delegated Employee Name</p>
                  <FormGroup>
                      <Input
                      disabled = {true}
                      value={data.DelegatedName}
                      type="text"
                      />
                  </FormGroup>
                             
              </div>
              <div>
                  <p>Delegated Task</p>
                  <FormGroup>
                      <Input
                      disabled = {true}
                      type ="text"
                      value={data.TaskDelegated}
                      />
                  </FormGroup>
                             
              </div>
              <div>
                  <p>Start Date</p>
                  <FormGroup>
                      <Input
                      disabled = {true}
                      type ="text"
                      value={moment(data.StartDate).format("DD/MM/YYYY")}
                      />
                  </FormGroup>
                             
              </div>
              <div>
                  <p>End Date</p>
                  <FormGroup>
                      <Input
                      disabled = {true}
                      type ="text"
                      value={moment(data.EndDate).format("DD/MM/YYYY")}
                      />
                  </FormGroup>
                             
              </div>
              <div>
                  <p>Created By</p>
                  <FormGroup>
                      <Input
                      disabled = {true}
                      type ="text"
                      value={data.CreatorName}
                      />
                  </FormGroup>
                             
              </div>
             
              <div>
                  <p>Created Date</p>
                  <FormGroup>
                      <Input
                      disabled = {true}
                      type ="text"
                      value={moment(data.DateIn).format("DD/MM/YYYY")}
                      />
                  </FormGroup>
                             
              </div>
             
  
            </div>
          </div>
          )
      }
      else if(data.Status !== '001' && !data.RevokedReason && data.UpdatedReason){
        return(
            <div>
            <div>
              <div className='select-wrapper'>
                  <p>Delegated Employee Name</p>
                  <FormGroup>
                      <Input
                      disabled = {true}
                      value={data.DelegatedName}
                      type="text"
                      />
                  </FormGroup>
                             
              </div>
              <div>
                  <p>Delegated Task</p>
                  <FormGroup>
                      <Input
                      disabled = {true}
                      type ="text"
                      value={data.TaskDelegated}
                      />
                  </FormGroup>
                             
              </div>
              <div>
                  <p>Start Date</p>
                  <FormGroup>
                      <Input
                      disabled = {true}
                      type ="text"
                      value={moment(data.StartDate).format("DD/MM/YYYY")}
                      />
                  </FormGroup>
                             
              </div>
              <div>
                  <p>End Date</p>
                  <FormGroup>
                      <Input
                      disabled = {true}
                      type ="text"
                      value={moment(data.EndDate).format("DD/MM/YYYY")}
                      />
                  </FormGroup>
                             
              </div>
              <div>
                  <p>Created By</p>
                  <FormGroup>
                      <Input
                      disabled = {true}
                      type ="text"
                      value={data.CreatorName}
                      />
                  </FormGroup>
                             
              </div>
             
              <div>
                  <p>Created Date</p>
                  <FormGroup>
                      <Input
                      disabled = {true}
                      type ="text"
                      value={moment(data.DateIn).format("DD/MM/YYYY")}
                      />
                  </FormGroup>
                             
              </div>
              <div>
                  <p>Updated By</p>
                  <FormGroup>
                      <Input
                      disabled = {true}
                      type ="text"
                      value={data.UpdateName}
                      />
                  </FormGroup>
                             
              </div>
              <div>
                  <p>Updated Date</p>
                  <FormGroup>
                      <Input
                      disabled = {true}
                      type ="text"
                      value={moment(data.DateUp).format("DD/MM/YYYY")}
                      />
                  </FormGroup>
                             
              </div>
              <div>
                  <p>Reason Update</p>
                  <FormGroup>
                      <Input
                      disabled = {true}
                      type ="text"
                      value={data.UpdatedReason}
                      />
                  </FormGroup>
                             
              </div>
             
            </div>
          </div>
          )
      }
    }

    return (
      <ModalWrapper
        title={`Task Delegation Details`}
        isVisible={isVisible}
        onClose={onClose}
      >
       {renderContent()}
      </ModalWrapper>
    );
  };

export default ModalDetail